import React from 'react'
import PropTypes from 'prop-types'

import { Box, FormControlLabel, Switch, Typography } from '@material-ui/core'

class ActivateStep extends React.Component {
  render() {
    return (
      <Box
        bgcolor={this.props.editable ? 'background.paper' : 'grey.100'}
        borderRadius="borderRadius"
        p={2}
        mb={2}
      >
        <Typography
          variant="h6"
          component="h5"
          gutterBottom
        >
          Step 4: Activate SFTP Delivery
        </Typography>
        <Typography gutterBottom>
          Once active, Scoir will send batches to your SFTP server on a nightly basis.
        </Typography>

        <Box my={2}>
          <FormControlLabel
            label="SFTP Delivery"
            disabled={!this.props.editable}
            color="primary"
            control={
              <Switch
                checked={this.props.activeIntegration}
                onChange={(e) => this.props.onToggleActivation(e.target.checked)}
                color="primary"
              />
            }
          />
        </Box>
      </Box>
    )
  }
}

ActivateStep.propTypes = {
  editable: PropTypes.bool.isRequired,
  activeIntegration: PropTypes.bool.isRequired,
  onToggleActivation: PropTypes.func.isRequired,
}

export default ActivateStep
